var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",staticClass:"frame-sketchfab",attrs:{"sandbox":"allow-scripts allow-same-origin allow-popups allow-forms","frameborder":"0","hspace":"0","vspace":"0","marginheight":"0","marginwidth":"0","allow":"autoplay; fullscreen; vr","allowvr":"","allowfullscreen":"","mozallowfullscreen":"true","webkitallowfullscreen":"true"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8989a0e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skecthfabFrame/SketchfabFrame.vue
// module id = null
// module chunks = 